import styles from "./NoResultFound.module.scss";

import classNames from "classnames";

// components
import Blob from "components/icons/Blob";

// assets
import NoResultsImage from "assets/images/error.png";

// store
import useFiltersStore from "store/useFiltersStoreNew";

type NoResultFoundProps = {
  content: string;
  className?: string;
} & JSX.IntrinsicElements["div"];

export default function NoResultFound(props: NoResultFoundProps) {
  const { content, className, ...rest } = props;
  const classes = classNames(styles["no-result-root"], className);

  const { clearFilters } = useFiltersStore((state) => ({
    clearFilters: state.clearFilters,
  }));

  return (
    <div className={classes} {...rest}>
      <div className={styles["blob"]}>
        <Blob />
        <img src={NoResultsImage} alt="Illustration of a storefront with a gone fishing sign, indicating no results were found" />
      </div>

      <div className={styles["group"]}>
        <h1>No results</h1>
        <p className={styles["desc"]}>
          {content}
        </p>
        <button
        className={styles["btn"]}
          type="button"
          onClick={clearFilters}
        >
          Reset search
        </button>
      </div>
    </div>
  );
}